import React, { memo } from 'react';
import { oneOf, bool, string, shape } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { click } from './events';
import './zone-card.scss';

const RentalZoneCard = ({ channel, major, header, details }) => {

  const { title, description: headerDescription } = header;
  const { description: detailsDescription, link, imageUrl } = details;

  const renderRentalZoneCardDesktop = () => (
    <>
      {major
        ? (
          <section className="zone-card__zone1">
            <div className="zone-card__header-wrapper">
              <h2 className="zone-card__header u__bold">{title}</h2>
              <p className="zone-card__header-text">Rent a {headerDescription}</p>
            </div>
            <div className="zone-card-details">
              <div className="zone-card-details__image">
                <Image src={imageUrl} alt="" stretchy />
              </div>
              <div className="zone-card-details__description">
                <div className="zone-card-details__logo">Tool Rental</div>
                <div className="zone-card-details__text">
                  Prefer to Rent?
                  <br />
                  Your store may have the right solution!
                </div>
                <div className="zone-card-details__actions">
                  <a
                    className="bttn-outline bttn-outline--primary bttn--inline zone-card-details__btn"
                    href={link}
                    onClick={() => {
                      click({
                        pageNumber: 1,
                        position: 'r1',
                        type: title
                      });
                    }}
                  >
                    <span className="bttn__content">View Rentals</span>
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
        : (
          <section className="zone-card__zone2">
            <div className="zone-card__header-wrapper toolrental-headerwrapper">
              <h2 className="u__truncate zone-card__header u__bold">{title}</h2>
              <p className="zone-card__header-text">{headerDescription}</p>
              <div className="zone-card-details__logo" style={{ marginTop: 10 }}>Tool Rental</div>
            </div>
            <div className="zone-card-details">
              <div className="zone-card-details__image">
                <Image src={imageUrl} alt="" stretchy />
              </div>
            </div>
            <div className="zone-card-details__actions">
              <a
                className="bttn-outline bttn-outline--primary bttn--inline zone-card-details__btn"
                href={link}
                onClick={() => {
                  click({
                    pageNumber: 1,
                    position: 'r1',
                    type: title
                  });
                }}
              >
                <span className="bttn__content">View Rentals</span>
              </a>
            </div>
          </section>
        )}
    </>
  );

  const renderRentalZoneCardMobile = () => (
    <a className="carousel-card" href={link}>
      <div className="carousel-card__header-wrapper">
        <div className="carousel-card__header u__bold carousel-card__rental-header">{title}</div>
        <div className="carousel-card__header-text">{headerDescription}</div>
        <div className="carousel-card__title-border" />
        <div className="carousel-card__description">
          <div className="carousel-card__text carousel-card__text--truncate carousel-card__rental-text">
            {detailsDescription}
          </div>
        </div>
      </div>
      <div className="carousel-card__image-wrapper">
        <div className="carousel-card__image">
          <Image src={imageUrl} alt="" />
        </div>
      </div>
    </a>
  );

  return channel === 'desktop'
    ? renderRentalZoneCardDesktop()
    : renderRentalZoneCardMobile();
};

RentalZoneCard.displayName = 'CategoryCards-RentalZoneCard';

RentalZoneCard.propTypes = {
  channel: oneOf(['desktop', 'mobile']),
  header: shape({
    title: string,
    description: string
  }).isRequired,
  details: shape({
    imageUrl: string,
    description: string,
    link: string
  }).isRequired,
  major: bool
};

RentalZoneCard.defaultProps = {
  channel: 'desktop',
  major: false
};

const MemoRentalZoneCard = memo(RentalZoneCard);

export { MemoRentalZoneCard as RentalZoneCard };
